import { render } from "./AddPost.vue?vue&type=template&id=d0c9e1ac&scoped=true"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import "./AddPost.vue?vue&type=style&index=0&id=d0c9e1ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c9e1ac"]])

export default __exports__